import { FC, HTMLProps } from 'react'

import '@/components/Text/Text.scss'

type Props = HTMLProps<HTMLParagraphElement> & {
  animation?: boolean
}

const Text: FC<Props> = ({ children, animation = true, ...rest }) => {
  return (
    <div key={(children || '').toString()} className="c-text" {...rest}>
      {animation ? (
        <>
          <span className="c-text--inner">{children}</span>
          <span className="c-text--outer">{children}</span>
        </>
      ) : (
        children
      )}
    </div>
  )
}

export default Text
